import PropTypes from 'prop-types';
import { fieldTypes } from './constants';

export const FieldType = PropTypes.oneOf(Object.values(fieldTypes));

export const FieldCallMethodResult = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

export const FieldPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  queryParamNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  allowMultiSelect: PropTypes.bool,
  // allowMultiSelect: PropTypes.oneOf([0, 1]),
  callMethod: PropTypes.string,
  callMethodFields: FieldCallMethodResult,
});

export const ExportTypeExtensions = PropTypes.oneOf(['xlsx']);

export const ExportTypesPropType = PropTypes.shape({
  extension: ExportTypeExtensions.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});
